{dispatchResizeEvent} = require('../../../../utils')

module.exports = (
  $scope,
  workers,
  $state,
  $timeout,
  $cookies,
  Api
) ->

  # =========================
  # ----- Soft routing ------
  # =========================

  $scope.setActiveTab( 'search' )

  if $state.current.name == 'project.workflow.step.iteration.facets'
    if workers.getCount() == 1 and !$scope.searchNotYetStarted()
      $state.go('.worker', {workerId: workers[0].id})
    else if (
      !$scope.searchNotYetStarted() and $scope.checkForNoResults() and
      workers.hasAcceptingResults()
    )
      $state.go('.worker', {workerId: workers.getAcceptingResults()[0].id})
    else
      $state.go('.overview')

  sidebarCookie = $cookies.isSidebarCollapsed
  $scope.isSidebarCollapsed = if sidebarCookie == "true" then true else false
  $scope.setSidebarCollapsed = (state) ->
    $scope.isSidebarCollapsed = state
    $cookies.isSidebarCollapsed = state

    # trigger window resize event so dygraph knows something's changed
    # 0 ms timeout to put this in the back in the execution queue so
    # that the browser can finish rendering DOM
    # see: https://stackoverflow.com/questions/779379/why-is-settimeoutfn-0-sometimes-useful
    $timeout (() -> dispatchResizeEvent), 0, false

  $scope.$watch(
    () -> workers.allHaveFinished(),
    (areFinishedNow, wereFinishedBefore) ->
      if areFinishedNow and workers.getWithResultsCount() == 1
        workerWithResults = workers.getWithResults()[0]
        $state.go('project.workflow.step.iteration.facets.worker', {workerId: workerWithResults.id}))
